<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="套餐名称："  label-for="key">
              <Input search enter-button clearable placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加套餐</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="cateInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical"/>
          <a @click="del(row,'删除',index)">删除</a>
        </template>
        <template slot-scope="{ row, index }" slot="image">
          <div class="tabBox_img">
            <img :src="row.image ? row.image : require('@/assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <categoryEdit ref="cateEdit" :id="id" @updateStatusModel="updateStatusModel"></categoryEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="套餐" :id="id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { vipList, delCate, changeStatus } from '@/api/vip'
import modalSure from '@/components/modalSure'
import categoryEdit from './components/categoryEdit'
export default {
  name: 'goodsCateList',
  components: { modalSure, categoryEdit },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        pid: 0 // 正常商品分类
      },
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      modelApi: delCate,
      pidArr: [],
      id: 0,
      dataCount: 0,
      cateInfo: [],
      loading: false,
      columns2: [
        {
          title: '套餐名称',
          key: 'title',
          minWidth: 120
        },
        {
          title: '图片',
          slot: 'image',
          minWidth: 120
        },
        {
          title: '价格',
          key: 'price',
          minWidth: 120
        },
        {
          title: '会员时长（天）',
          key: 'day',
          minWidth: 120
        },
        {
          title: '每天多少钱',
          key: 'per_fee',
          minWidth: 120
        },
        {
          title: '平台费',
          key: 'plant_fee',
          minWidth: 120
        },
        {
          title: '排序',
          key: 'sort',
          minWidth: 120
        },
        {
          title: '状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.categoryList()
  },
  methods: {
    categoryList () {
      this.loading = true
      vipList(this.userForm).then(res => {
        let data = res.data
        this.cateInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.categoryList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.categoryList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.id = id
      this.$refs.cateEdit.isShow = true
    },
    add () {
      this.id = 0
      this.$refs.cateEdit.isShow = true
    },
    updateStatusModel () {
      this.reload()
    },
    del (row) {
      this.id = row.id
      this.$refs.modalSure.isShow = true
    },
    closeModal () {
      this.categoryList()
    },
    // 上下架
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.categoryList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    onChangeStatus () {
      this.categoryList()
    }
  }
}
</script>
